import { ReactElement, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useGetArticleQuery } from "../gateways/cms/articleApi";

// 記事一覧では配信先が6件以上ある場合、5件目までしか取得しない(表示・パフォーマンスの都合)。
// ホバー時に記事詳細APIを呼び、省略された配信先も含めた全件をツールチップで表示する。
export interface Props {
    articleId: number;
    children: ReactElement;
}

export function DeliveryAllTooltip({ articleId, children }: Props) {
    const [hasHovered, setHasHovered] = useState(false);
    const article = useGetArticleQuery(articleId, { skip: !hasHovered });

    const getTitle = () => {
        if (!hasHovered) return "";
        if (article.isFetching) return "読み込み中...";
        if (!article.data?.delivery || article.data.delivery.length === 0) {
            return "配信先を取得できませんでした";
        }
        return (
            <ul style={{ margin: 0, paddingLeft: "1.2em" }}>
                {article.data.delivery.map((deliveryItem) => (
                    <li key={deliveryItem.organizationId}>
                        {deliveryItem.name}
                        {deliveryItem.deliveryGroup?.length > 0 && (
                            <>&#40;{deliveryItem.deliveryGroup.map((g) => g.name).join("、")}&#41;</>
                        )}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <Tooltip title={getTitle()} onOpen={() => setHasHovered(true)} arrow>
            {children}
        </Tooltip>
    );
}
